import { useState } from "react";
import axiosInstance from "../../axiosInstance";
import { ProcessoI } from "./interface";

type ExportacaoZipResponse = {
    txDescricao: string;
    txTipoArquivo: string;
    file_stream: string;
};

const parseFileNameFromDisposition = (contentDisposition?: string) => {
    if (!contentDisposition) return "";
    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match?.[1]) {
        return decodeURIComponent(utf8Match[1]);
    }
    const plainMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
    return plainMatch?.[1] || "";
};

const arrayBufferToBase64 = (buffer: ArrayBuffer) => {
    const bytes = new Uint8Array(buffer);
    const chunkSize = 0x8000;
    let binary = "";

    for (let i = 0; i < bytes.length; i += chunkSize) {
        const chunk = bytes.subarray(i, i + chunkSize);
        binary += String.fromCharCode(...chunk);
    }

    return btoa(binary);
};

const useProcessosService = () => {
    const [processo, setProcesso] = useState<ProcessoI>();
    const [processos, setProcessos] = useState<ProcessoI[]>([]);

    const getAll = () =>
        new Promise(
            async (
                resolve: (res: any) => void,
                reject: (res: string) => void
            ) => {
                try {
                    //console.log('getAll');
                    const res = await axiosInstance.get("/api/v1.0/Processos");
                    //console.log('res', res.data.data);
                    setProcessos(res.data.data);
                    resolve(res.data.data);
                } catch (err) {
                    reject(err as any);
                }
            }
        );

    const get = (processoId: number) =>
        new Promise(
            async (
                resolve: (res: any) => void,
                reject: (res: string) => void
            ) => {
                try {
                    const res = await axiosInstance.get(
                        `/api/v1.0/Processos/${processoId}`
                    );

                    setProcesso(res.data.data);
                    resolve(res.data.data);
                } catch (err) {
                    reject(err as any);
                }
            }
        );


    const autoComplete = (processoId: string) =>
        new Promise(
            async (
                resolve: (res: any) => void,
                reject: (res: string) => void
            ) => {
                try {
                    // http://nucleo.pge.rn.gov.br/jvris-api/api/v1.0/Processos/autocomplete?txNumero=43234&page=1&pageSize=10
                    const res = await axiosInstance.get(
                        `/api/v1.0/Processos/autocomplete?txNumero=${processoId}&page=1&pageSize=10`
                    );
                    
                    setProcessos(res.data.data);
                    resolve(res.data.data);

                } catch (err) {
                    reject(err as any);
                }
            }
        );



    const exportarZip = (
        processoId: number,
        idModeloPeca?: number
    ): Promise<ExportacaoZipResponse> =>
        new Promise(async (resolve, reject) => {
            try {
                const query =
                    idModeloPeca && idModeloPeca > 0
                        ? `?idModeloPeca=${idModeloPeca}`
                        : "";
                const res = await axiosInstance.get(
                    `/api/v1.0/Processos/${processoId}/exportacao-zip${query}`,
                    { responseType: "arraybuffer" }
                );

                const contentType =
                    (res.headers?.["content-type"] as string | undefined)?.toLowerCase() ||
                    "";
                const isJson =
                    contentType.includes("application/json") ||
                    contentType.includes("text/json");

                if (isJson) {
                    const decoded = new TextDecoder("utf-8").decode(res.data);
                    const json = JSON.parse(decoded);

                    if (!json?.data?.file_stream) {
                        reject(json?.message || "Falha ao gerar exportação ZIP");
                        return;
                    }

                    resolve(json.data as ExportacaoZipResponse);
                    return;
                }

                const nomeArquivo =
                    parseFileNameFromDisposition(
                        res.headers?.["content-disposition"] as string | undefined
                    ) || `processo-${processoId}-exportacao.zip`;
                const tipoArquivo =
                    (res.headers?.["content-type"] as string | undefined) ||
                    "application/zip";

                resolve({
                    txDescricao: nomeArquivo,
                    txTipoArquivo: tipoArquivo,
                    file_stream: arrayBufferToBase64(res.data)
                });
            } catch (err) {
                reject(err as any);
            }
        });

    return { get, getAll, processo, autoComplete, processos, exportarZip };
};

export default useProcessosService;
